import { createSlice } from '@reduxjs/toolkit';

const today = () => new Date();

const toISODate = (d: Date) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const monthStartISO = () => {
  const d = today();
  return toISODate(new Date(d.getFullYear(), d.getMonth(), 1));
};

const monthEndISO = () => {
  const d = today();
  return toISODate(new Date(d.getFullYear(), d.getMonth() + 1, 0));
};

const initialState = {
  coursereport: [],
  cardReport: '',
  pageIndex: 1,
  courseReportSort: [],
  size: 10,
  deleted: false,
  userCoursepageIndex: 1,
  userCoursepageSize: 10,
  userCourseTotalCount: 0,
  userCourseSearch: undefined,
  userCourseTable: [],
  userOverviewSearch : undefined,
  selectedStatus: '',
  subscriptionStatus: 'all',
  userCourseStartDate: monthStartISO(),
  userCourseEndDate: monthEndISO()
};

const userreport = createSlice({
  name: 'userreport',
  initialState,
  reducers: {
    updatecoursereport(state, action) {
      state.coursereport = action.payload;
    },
    setUserCourseSearch(state, action) {
      state.userCourseSearch = action.payload;
    },
    setUserOverviewSearch(state, action) {
      state.userOverviewSearch = action.payload;
    },
    setSortCourse(state, action) {
      state.courseReportSort = action.payload;
    },
    setUserCourseStatus(state, action) {
      state.deleted = action.payload;
    },
    setCardReport(state, action) {
      state.cardReport = action.payload;
    },
    setuserCourseTotalCount(state, action) {
      state.userCourseTotalCount = action.payload;
    },
    setUserCourseTable(state, action) {
      state.userCourseTable = action.payload;
    },
    setcoursereportPageIndex(state, action) {
      return {
        ...state,
        pageIndex: action.payload
      };
    },
    setUserCourseListPage(state, action) {
      state.userCoursepageIndex = action.payload;
    },
    setUserCourseListSize(state, action) {
      state.userCoursepageSize = action.payload;
    },
    delcoursereport(state: any, action) {
      state.coursereport.courseList = state.coursereport.courseList.filter((item: { _id: any }) => item._id !== action.payload);
    },
    setcoursereportTableSize(state, action) {
      return {
        ...state,
        size: action.payload
      };
    },
    resetStatecoursereport: (state) => {
      return initialState;
    },
    setSelectedStatus(state, action) {
      state.selectedStatus = action.payload;
    },
    setSubscriptionStatus(state, action) { 
      state.subscriptionStatus = action.payload;
  },
    setUserCourseStartDate(state, action) {
      state.userCourseStartDate = action.payload;
    },
    setUserCourseEndDate(state, action) {
      state.userCourseEndDate = action.payload;
    }
  }
});

export const {
  updatecoursereport,
  setUserCourseTable,
  setuserCourseTotalCount,
  setUserCourseStatus,
  setUserCourseListSize,
  setUserCourseListPage,
  setCardReport,
  setUserCourseSearch,
  setSortCourse,
  delcoursereport,
  setcoursereportPageIndex,
  setcoursereportTableSize,
  resetStatecoursereport,
  setUserOverviewSearch,
  setSelectedStatus,
  setSubscriptionStatus,
  setUserCourseStartDate,
  setUserCourseEndDate
} = userreport.actions;
export default userreport.reducer;
